import * as React from 'react';
import { observer } from 'mobx-react';
import { Context } from 'bernie-context';

import { ESSAdapter, TypeaheadSelection, TypeaheadToolbarVersion, UitkTypeahead } from 'uitk-react-typeahead';

import { FlightsSearchFormLocationFieldType } from 'types/search/wizard';

export interface LocationInputProps {
  context?: Context;
  dest?: boolean;
  name: string;
  stid?: string;
  onInputChange: () => void;
  onUpdate: (selection: TypeaheadSelection) => void;
  handleClear?: () => void;
  location: FlightsSearchFormLocationFieldType;
  essEndpoint?: string;
  onSetDestinationRef?: (ref: React.Ref<HTMLButtonElement>) => void;
  onSetOriginRef?: (ref: React.Ref<HTMLButtonElement>) => void;
  renderDialog?: (children: JSX.Element) => JSX.Element;
  onClick?: (renderType: string) => void;
  onDismiss?: (renderType: string) => void;
}

export const LocationInput = observer(
  ({
    context,
    name,
    dest,
    stid,
    onInputChange,
    onUpdate,
    handleClear,
    location,
    essEndpoint,
    onSetDestinationRef,
    onSetOriginRef,
    onClick,
    renderDialog,
    onDismiss
  }: LocationInputProps) => {
    const isDest = dest || false;
    const { currentError, label, icon, placeholder, value } = location;

    const setLocationRef = (refData: React.Ref<HTMLButtonElement>) => {
      isDest ? onSetDestinationRef(refData) : onSetOriginRef(refData);
    };

    return (
      <UitkTypeahead
        adapter={
          new ESSAdapter({
            client: 'Flights.Search',
            dest: isDest,
            features: 'ta_hierarchy|nearby_airport',
            guid: context && context.deviceId,
            lob: 'FLIGHTS',
            locale: context && context.locale,
            maxResults: 10,
            regionType: 95,
            siteId: context && context.site && context.site.id,
            domain: essEndpoint
          })
        }
        allowExactMatch={true}
        handleClear={handleClear}
        icon={icon.id}
        label={label}
        onInputChange={onInputChange}
        onUpdate={onUpdate}
        name={name}
        stid={stid}
        value={value}
        renderDialog={renderDialog}
        onClick={onClick}
        onDismiss={onDismiss}
        toolbarVersion={TypeaheadToolbarVersion.V2}
        typeaheadPlaceholder={placeholder}
        invalid={currentError}
        onMountCB={setLocationRef}
      />
    );
  }
);
